import { Tuple } from '@mantine/core';

type MantineColorsTuple = Tuple<string, 10>;

export const blue: MantineColorsTuple = [
	'#F2F7FF',
	'#E6EFFB',
	'#D7E3F3',
	'#BDCFE8',
	'#8DADD8',
	'#6187BD',
	'#426DA9',
	'#1D4F91',
	'#1E4376',
	'#183052'
];

export const purple: MantineColorsTuple = [
	'#FEF2FF',
	'#F0D8F3',
	'#DFB5E5',
	'#D08AD9',
	'#C478CE',
	'#A64EB1',
	'#883B92',
	'#66296E',
	'#55195C',
	'#341238'
];

export const magenta: MantineColorsTuple = [
	'#FFF0FB',
	'#FCCFF0',
	'#F6A2DF',
	'#EC78CB',
	'#DC65BC',
	'#C5349F',
	'#AF1685',
	'#870D66',
	'#6C0450',
	'#430432'
];

export const raspberry: MantineColorsTuple = [
	'#FFF1F8',
	'#FCCFE4',
	'#F8B9D7',
	'#F48ABC',
	'#E968A4',
	'#E63888',
	'#C81468',
	'#A70651',
	'#7D0844',
	'#600333'
];

export const red: MantineColorsTuple = [
	'#FFF0F3',
	'#FFCCD5',
	'#FFA3B4',
	'#FF6380',
	'#FC1D47',
	'#E4002B',
	'#B20021',
	'#8F001A',
	'#660012',
	'#550010'
];

export const green: MantineColorsTuple = [
	'#F2FFF8',
	'#D0F6E2',
	'#9AE8C0',
	'#73FDB3',
	'#5CD094',
	'#15BC66',
	'#009F4D',
	'#007A3B',
	'#005C2C',
	'#004220'
];

export const yellow: MantineColorsTuple = [
	'#FFFBF0',
	'#FFF1CC',
	'#FFE499',
	'#FFD152',
	'#FEC025',
	'#FBBC0E',
	'#D49A00',
	'#A37800',
	'#815F00',
	'#574000'
];

export const sapphire: MantineColorsTuple = [
	
	'#F2FCFF',
	'#D0EFF8',
	'#AFE2F1',
	'#79C8DE',
	'#5BC0DF',
	'#4AAFCC',
	'#2197B9',
	'#0081A6',
	'#006580',
	'#004759'
];

export const teal: MantineColorsTuple = [
	'#F2FFFE',
	'#C6F7F4',
	'#AAFDF8',
	'#9BEFEA',
	'#5FDAD4',
	'#2BC6BE',
	'#00B2A9',
	'#00948C',
	'#00756F',
	'#005752'
];

export const lime: MantineColorsTuple = [
	'#FEFFF2',
	'#FDFDE7',
	'#F7F9CC',
	'#F0F3A7',
	'#DCE26D',
	'#CAD03B',
	'#B7BF10',
	'#979E08',
	'#777D03',
	'#575C00'
];

export const orange: MantineColorsTuple = [
	'#FFF9F2',
	'#FFEED7',
	'#FFE3BA',
	'#FFC684',
	'#FFAA4F',
	'#FF9C36',
	'#FF8F1C',
	'#CC6B0A',
	'#995006',
	'#663100'
];

export const gray: MantineColorsTuple = [
	'#F6F6F6',
	'#EAEAEA',
	'#D6D6D6',
	'#C1C1C1',
	'#A7A7A7',
	'#8C8C8C',
	'#717171',
	'#585858',
	'#404040',
	'#333333'
];
